<template>
    <div class="computerBox">
        <topBox :title="$route.meta.title" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">

            <!-- 用户信息 -->
            <div class="my-2">
                <div class="flex flex-col items-center rounded-[24px] border bg-white px-[35px] py-[20px] shadow-lg">
                    <img class="block h-[50px] w-[50px] rounded-full border-2 border-white shadow" :src="`/img/avatar_2.png`" alt="user avatar" />
                    <div class="mt-3 text-m14 font-semibold text-slate-900">{{ stats.title }}：  &nbsp;&nbsp;  {{ api.account }}</div>
                    <div class="mt-1 text-m14 text-slate-400"> 帐户余额： ¥{{ Number(api.balance) + Number(stats.monthDirectCommission) }}</div>
                </div>
            </div>


            <!-- 充值 / 提现 -->
            <div class="grid grid-cols-2 gap-3 py-[10px]">
                <button
                    class="block w-full px-3 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                    @click="$router.push('/recharge')"
                >
                    {{ $t('but.recharge') }}
                </button>
                <button
                    class="block w-full px-3 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                    @click="$router.push('/computer/withdraw')"
                >
                    {{ $t('but.withdraw') }}
                </button>
            </div>

            <!-- 数据统计 -->
            <div class="my-3">
                <div class="grid grid-cols-2 gap-3">
                    <router-link to="/computer/subordinates" class="stat-card">
                        <div class="text-14 text-slate-400">{{ $t('text.MySubordinates') }}</div>
                        <div class="mt-1 text-m14 font-semibold text-slate-900">{{ stats.subordinates }}</div>
                    </router-link>
                    <router-link to="/computer/team" class="stat-card">
                        <div class="text-14 text-slate-400">{{ $t('text.MyTeam') }}</div>
                        <div class="mt-1 text-m14 font-semibold text-slate-900">{{ stats.team }}</div>
                    </router-link>
                    <router-link to="/computer/month-direct-recharge" class="stat-card">
                        <div class="text-14 text-slate-400">{{ $t('text.MonthDirectRecharge') }}</div>
                        <div class="mt-1 text-m14 font-semibold text-slate-900">{{ stats.monthDirectAmount }} &nbsp;&nbsp;  {{ stats.percentage }}%</div>
                    </router-link>
                    <div class="rounded-[20px] border bg-white px-[20px] py-[10px] shadow-lg text-center">
                        <div class="text-14 text-slate-400">{{ $t('text.MonthDirectCommission') }}</div>
                        <div class="mt-1 text-m14 font-semibold text-slate-900">{{ stats.monthDirectCommission }}</div>
                    </div>
                </div>
            </div>

            <!-- 快捷操作 -->
            <div class="my-3">
                <h1 class="text-m14 font-semibold title text-left mb-[10px]">{{ $t('text.quickAction') }}</h1>
                <div class="grid grid-cols-3 gap-2">
                   
                    <router-link to="/computer/receiving/payments" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                            <path fill="currentColor" d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"/>
                        </svg>
                        <div>{{ $t('text.revision') }}</div>
                    </router-link>
                    <router-link to="/computer/treasure-plate" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                            <path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"/>
                        </svg>
                        <div>{{ $t('text.guide') }}</div>
                    </router-link>
                    <!-- <router-link to="/serve" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M480 160H32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zm-48-88c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm112 248H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zm-48-88c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm112 248H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zm-48-88c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"/>
                        </svg>
                        <div>{{ $t('text.serve') }}</div>
                    </router-link>
                    <router-link to="/company/profile" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path fill="currentColor" d="M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"/>
                        </svg>
                        <div>{{ $t('text.companyProfile') }}</div>
                    </router-link> -->
                    <div class="action-item" @click="out">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M288 130.5V112h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16v18.5C115.5 146.1 32 239.2 32 352h448c0-112.8-83.5-205.9-192-221.5zM496 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"/>
                        </svg>
                        <div>{{ $t('page.out') }}</div>
                    </div>
                    <!-- <router-link to="/computer/publish/article" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path fill="currentColor" d="M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"/>
                        </svg>
                        <div>发布图文</div>
                    </router-link> -->
                    <!-- 这个功能藏起来，自己测试用的 -->
                    <!-- <router-link to="/computer/live" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                            <path fill="currentColor" d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c15.2 10.5 26.4 1.3 26.4-11.9V113.6c0-13.2-11.2-22.4-26.4-11.9z"/>
                        </svg>
                        <div>{{ $t('page.live') }}</div>
                    </router-link> -->
                    <router-link to="/computer/invite" class="action-item">
                        <svg class="action-icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m9.86-2.54a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                        </svg>
                        <div>{{ $t('page.inviteLink') }}</div>
                    </router-link>
                    <router-link to="/computer/edit/password" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path fill="currentColor" d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"/>
                        </svg>
                        <div>{{ $t('page.password') }}</div>
                    </router-link>
                    <router-link to="/computer/withdraw/password" class="action-item">
                        <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"/>
                        </svg>
                        <div>{{ $t('page.passwordFund') }}</div>
                    </router-link>
                    
                </div>
            </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import axios from 'axios'
import { layer } from 'vue3-layer'
import global from '@/assets/js/global'
import { useGlobalStore } from '@/assets/js/globalStore'

export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            lang: '',
            api: {
                account: null,
                // uid: 0,
                invite: null,
                bank_id: null,
                grade: '',
                balance: 0,
                frozen: 0,
            },
            stats: {
                subordinates: 0,
                team: 0,
                monthDirectAmount: 0,
                monthDirectCommission: 0,
                monthTeamCommission: 0,
            },
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
        this.getInfo()
        this.getReferralStats()
    },
    methods: {
        getReferralStats() {
            axios.get(
                '/api/m/referral/stats',
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    // console.log(response.data.data)
                    this.stats.title = response.data.data.job_title
                    this.stats.percentage = response.data.data.job_percentage
                    this.stats.subordinates = response.data.data.subordinates || 0  // 部下数量
                    this.stats.team = response.data.data.team || 0  // 团队数量
                    this.stats.monthDirectAmount = response.data.data.month_amount || 0  // 本月部下充值
                    this.stats.monthDirectCommission = response.data.data.month_commission || 0  // 本月部下分润
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        getInfo() {
            axios.post(
                '/api/m/info/user',
                {},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    this.api.bank_id = response.data.data.bank_id
                    this.api.account = response.data.data.account
                    this.api.grade = `VIP${response.data.data.grade}`
                    // this.api.uid = response.data.data.uid
                    this.api.invite = response.data.data.uuid
                    this.api.balance = response.data.data.balance
                    this.api.frozen = response.data.data.frozen
                    global.balance = response.data.data.balance
                } else {
                    if (response.data.code === 911) localStorage.removeItem('isLogin')
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        out() {
            axios.post(
                '/api/m/out',
                {},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    localStorage.removeItem('token')
                    localStorage.setItem('isLogin', 0)
                    localStorage.setItem('isAgent', 0)
                    global.balance = 0
                    global.isLogin = 0
                    useGlobalStore().setLogin(false)
                    useGlobalStore().setIsAgent(false)
                    this.$router.push({
                        path: '/computer/login',
                        query: {
                            msg: 'account out',
                        },
                    })
                } else {
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}

.action-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 4px;
    border-radius: 20px;
    background: #fff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #334155;
    text-align: center;
    cursor: pointer;
    text-decoration: none;
}

.action-icon {
    width: 28px;
    height: 28px;
    margin-bottom: 6px;
    color: #22c55e;
}

.stat-card {
    display: block;
    border-radius: 20px;
    border: 1px solid #e5e7eb;
    background: #fff;
    padding: 10px 20px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
    text-align: center;
    text-decoration: none;
    color: inherit;
}
</style>
